import { useTheme } from '@mui/material/styles'
import {
  Grid,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  TextareaAutosize,
} from '@mui/material'
import { useCurrentStore, useOrdering } from 'hooks'
import { useTranslation } from 'react-i18next'
import { KCheckIconButton } from 'components/core/KCheckIconButton'
import { SubmitOrderSection } from './SubmitOrderSection'

interface OrderCheckedPropListItemProps {
  checked: boolean
  label: string
  description: string
  onClick?: () => void
}

const OrderBooleanPropListItem = ({
  checked,
  label,
  description,
  onClick,
}: OrderCheckedPropListItemProps) => {
  return (
    <ListItemButton onClick={onClick} sx={{ padding: 0.5 }}>
      <ListItem
        disableGutters
        disablePadding
        secondaryAction={
          <KCheckIconButton checked={checked} onClick={onClick} />
        }
      >
        <ListItemText
          primary={label}
          primaryTypographyProps={{ variant: 'h5', color: 'secondary' }}
          secondary={description}
          secondaryTypographyProps={{ variant: 'body2' }}
          sx={{ marginRight: 6 }}
        />
      </ListItem>
    </ListItemButton>
  )
}

export const OrderFootnotes = () => {
  const { t } = useTranslation()
  const theme = useTheme()
  const { store } = useCurrentStore()
  const { order, saveOrderProps } = useOrdering()

  return (
    <SubmitOrderSection label={t('Footnotes')}>
      <Grid container spacing={2.5}>
        <Grid item xs={12} sm={6}>
          <List disablePadding>
            <OrderBooleanPropListItem
              checked={order?.no_plastic_utensils === true}
              onClick={() =>
                saveOrderProps({
                  no_plastic_utensils: !order?.no_plastic_utensils,
                })
              }
              label={t('No Plastic Utensils.')}
              description={t(
                'Thank you for saving the planet. Reducing plastic waste is the way to go.',
              )}
            />
            {order?.order_type === 'delivery' && (
              <OrderBooleanPropListItem
                checked={order?.contactless_delivery === true}
                onClick={() =>
                  saveOrderProps({
                    contactless_delivery: !order?.contactless_delivery,
                  })
                }
                label={t('I want contactless delivery.')}
                description={t(
                  'Drop off at front porch, ring the bell and leave.',
                )}
              />
            )}
          </List>
        </Grid>
        {store?.footnotes_settings?.custom_note === true && (
          <Grid
            item
            xs={12}
            sm={6}
            sx={{
              mt: 1,
              '& textarea': {
                ...theme.typography.body2,
                border: `1px solid ${theme.palette.grey[400]}`,
                padding: 2,
                borderRadius: 2,
                width: `calc(100% - ${theme.spacing(5)})`,
                minWidth: `calc(100% - ${theme.spacing(5)})`,
                maxWidth: `calc(100% - ${theme.spacing(5)})`,
                height: 192,
                '&:focus': {
                  border: `2px solid `,
                  borderColor: theme.palette.primary.main,
                  outline: 'none',
                },
              },
            }}
          >
            <TextareaAutosize
              value={order?.custom_note}
              onChange={(e) => saveOrderProps({ custom_note: e.target.value })}
              placeholder={t('Note/Delivery Intruction')}
              maxLength={500}
              minRows={4}
            />
          </Grid>
        )}
      </Grid>
    </SubmitOrderSection>
  )
}
